"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notification = exports.message = void 0;

var noop = function noop() {};

var message = {
  warn: noop,
  error: noop
};
exports.message = message;
var notification = {
  open: noop
};
exports.notification = notification;